import { computed, Ref, ref } from "vue";
import { QrService } from "@/service/QrService";
import { LoginQr } from "@/types/Qr";
import { UtilService } from "@/service/UtilService";
import { NumberLiteralTypeAnnotation } from "@babel/types";

/*
 * 初期処理
 */
export function useLoginQr() {
  const loading = ref(0) // APIで読み込みをする本数
  const isError = ref(false)
  const service = new QrService()
  let loginQr: Ref<LoginQr | null> = ref(null)

  const getLoginQr = async (userId: number) => {
    loading.value++
    await init()
    try {
      loginQr.value = await service.getLoginQr(userId)
      if(!loginQr.value.qrBase64){
        loading.value--
        return false
      }
      loading.value--
      return true
    } catch (e: any) {
      await UtilService.showResponseErrorDialog(e)
      loading.value--
      return false
    }
  }

  const init = async () => {
    loginQr.value = null;
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  })

  return {
    isLoading,
    loginQr,
    getLoginQr
  }
}
